import { ErrorCode } from '@afterpaytouch/portal-api/types'

export const confirmPayErrors: Partial<Record<ErrorCode, string>> = {
  [ErrorCode.CardNotEnabled]: 'cardNotEnabled',
  [ErrorCode.InsufficientFunds]: 'insufficientFunds',
  [ErrorCode.UnsupportedCardType]: 'unsupportedCardType',
  [ErrorCode.UnsupportedCardIssuer]: 'unsupportedCardIssuer',
  [ErrorCode.CardExpiry]: 'cardExpiry',
  [ErrorCode.PreconditionFailed]: 'preconditionFailed',
  [ErrorCode.PaymentFailure]: 'paymentFailure',
}
